module.exports = __webpack_public_path__ + "static/elementspanelupdate-7892b6c5bba8ba5f9e32dfafe87e39f6.mp4";